export const EMaintenanceStatus = {
  DISABLED: 'DISABLED',

  PLANNED_TILL_RESTART_APP: 'PLANNED_TILL_RESTART_APP',
  ENABLED_TILL_RESTART_APP: 'ENABLED_TILL_RESTART_APP',

  ENABLED_TILL_MANUAL_DISABLE: 'ENABLED_TILL_MANUAL_DISABLE',
};
